import script from "./cLabel.vue?vue&type=script&lang=js"
export * from "./cLabel.vue?vue&type=script&lang=js"

import "./cLabel.vue?vue&type=style&index=0&id=80855834&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80855834"],['__file',"src/components/cmp/cLabel/cLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80855834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80855834', __exports__)) {
    api.reload('80855834', __exports__)
  }
  
}


export default __exports__